// import {ModulesMap} from './All';
import {BaseModulesRegister} from './_BaseRegister';

export class DynamicModulesRegister extends BaseModulesRegister {
	// module<K extends keyof ModulesMap>(moduleName: K): ModulesMap[K] {
	// 	return super.module(moduleName as any);
	// }
}
